import { render, staticRenderFns } from "./LeftBarNavGroupHeader.vue?vue&type=template&id=0ef0e73e&scoped=true&"
import script from "./LeftBarNavGroupHeader.vue?vue&type=script&lang=ts&"
export * from "./LeftBarNavGroupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBarNavGroupHeader.vue?vue&type=style&index=0&id=0ef0e73e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef0e73e",
  null
  
)

export default component.exports